import React from "react";
import { connect } from "react-redux";
import { Col, Row, Button, Modal, Form } from "react-bootstrap";
import {
  updateBillingPaymentMethodAction,
  getUserBillingPaymentMethodAction,
  getStripeKeyAction,
} from "../../../../actions/PaymentMethodActions";
import * as code from "../../../../config/Constants";
import {
  toastMessage,
  getMonthName,
  cryptoTokenDecode,
} from "../../../Common/Common";
import { Edit } from "@material-ui/icons";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AddBillingPaymentMethod from "./AddBillingPaymentMethod";
import * as message from "./../../../../config/CommonMessages";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../../config/Constants";
var CryptoJS = require("crypto-js");

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

class BillingPaymentMethodsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      methodInfo: "",
      paymentModal: false,
      paymentMethodId: "",
      ownerId:
        localStorage.getItem("usertype") === "VENDOR"
          ? localStorage.getItem("ownerId")
          : localStorage.getItem("ID"),
      usertype: localStorage.getItem("usertype"),
      permissionArray: [],
      stripePromise: "",
    };
  }

  componentWillMount() {
    this.getReactAppStripeKey();
    this.getUserPermissions();
    this.getUserBillingPaymentMethod();
  }

  getReactAppStripeKey() {
    this.setState({ showLoader: true });
    this.props.getStripeKeyAction().then((res) => {
      //console.log('getReactAppStripeKey getStripeKeyAction res',res);
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        var sKey = res.data;
        //console.log('getReactAppStripeKey OK sKey', sKey);
        let bytes = CryptoJS.AES.decrypt(sKey, REACT_APP_CRYPTO_SECRET_KEY);
        //console.log('getReactAppStripeKey OK bytes', bytes);
        let decryptedDataKey = bytes.toString(CryptoJS.enc.Utf8);
        //console.log('decryptedDataKey',decryptedDataKey);
        let stripePromise = loadStripe(decryptedDataKey);
        this.setState({ stripePromise });
      }
    });
  }

  getUserBillingPaymentMethod() {
    this.setState({ showLoader: true });
    this.props.getUserBillingPaymentMethodAction().then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        this.setState({ methodInfo: res.data });
      }
    });
  }

  setPaymentModal() {
    this.setState({ paymentModal: !this.state.paymentModal });
  }

  changeBillingPaymentMethod(paymentId) {
    this.setState({ showLoader: true });
    this.setPaymentModal();
    let data = {
      userId: this.state.ownerId,
      paymentMethodId: paymentId,
    };
    this.props.updateBillingPaymentMethodAction(data).then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        //toastMessage(code.SUCCESS, "Card details updated successfully");
        this.getUserBillingPaymentMethod();
      } else {
        toastMessage(code.ERROR, res.data);
        this.getUserBillingPaymentMethod();
      }
    });
  }

  getUserPermissions() {
    if (this.state.usertype === message.VENDOR) {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        // console.log("getUserPermissions decryptedData39", decryptedData);
        permissionarray = decryptedData.split(",");
        // console.log("getUserPermissions permissionarray", permissionarray);
        this.setState({ permissionArray: permissionarray });
      }
    }
  }

  checkPermission(checkFor) {
    if (this.state.usertype === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        this.state.permissionArray &&
        this.state.permissionArray.length > 0 &&
        checkFor.some((item) => this.state.permissionArray.includes(item));
      return hasSome;
    }
  }

  render() {
    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col className="col-auto" xs={12} sm={7}>
              <h4 className="title-med mt-0 pt-1">Billing Payment Method</h4>
            </Col>
            {this.state.methodInfo &&
              (!this.state.methodInfo.paymentMethods ||
                this.state.methodInfo.paymentMethods.length === 0) &&
              this.checkPermission([message.manage_payment_method]) && (
                <Col className="col-auto text-right" xs={12} sm={4}>
                  <Form.Group controlId="" className="mb-0">
                    <Button
                      variant="primary"
                      className="btn-blue btn-head hide-767"
                      onClick={() => this.setPaymentModal()}
                    >
                      Add Payment Method
                    </Button>
                  </Form.Group>
                </Col>
              )}
          </Row>

          <div className="subscription-detail master-template-container">
            <div className="manage-payment">
              {!!this.state.methodInfo.paymentMethods
                ? this.state.methodInfo.paymentMethods.map((card) => {
                    return (
                      <Row
                        className="manage-payment-row mb-3"
                        style={{ maxWidth: 400 }}
                      >
                        <Col sm={10}>
                          <ul className="cc-info">
                            <li className="generic_card">
                              <p className="cc-vendor">
                                {card.brand}&nbsp;{"****" + card.number}
                              </p>
                              <p className="cc-expiry">
                                Expires {getMonthName(card.expireMonth - 1)}
                                &nbsp;{card.expireYear}{" "}
                              </p>
                            </li>
                          </ul>
                        </Col>
                        {this.checkPermission([
                          message.manage_payment_method,
                        ]) && (
                          <Col sm={2}>
                            <div className="action-btns">
                              <Button
                                variant="transparent"
                                onClick={() => this.setPaymentModal()}
                              >
                                <Edit />
                              </Button>
                            </div>
                          </Col>
                        )}
                      </Row>
                    );
                  })
                : ""}
            </div>

            <Modal
              show={this.state.paymentModal}
              onHide={() => this.setPaymentModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med1 add-payment-method"
            >
              <Form className="form-sm form-admin">
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    Card Details
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col xs={12}>
                      <Elements stripe={this.state.stripePromise}>
                        <AddBillingPaymentMethod
                          addNewPaymentMethod={(id) =>
                            this.changeBillingPaymentMethod(id)
                          }
                          setPaymentModal={() => this.setPaymentModal()}
                        />
                      </Elements>
                    </Col>
                  </Row>
                </Modal.Body>
              </Form>
            </Modal>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    methodInfo: state.reducer.methodInfo,
  };
};
export default connect(
  mapStateToProps,
  {
    updateBillingPaymentMethodAction,
    getUserBillingPaymentMethodAction,
    getStripeKeyAction,
  }
)(BillingPaymentMethodsList);
